<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">

        <h3 class="ui header"> What is inventariarudolphina.com ?</h3>
        <p>
          The Inventaria Rudolphina database is created as an essential tool to analyse the painting collection of Emperor Rudolf II. Each entry is provided with keywords, artists’ names are linked to the Getty ULAN database and the themes of paintings are assigned the appropriate Iconclass number. The original location of pictures in the imperial gallery at Prague Castle is displayed on the plan. Thanks to the concordances of items within each inventory, it is possible to follow the circulation of artworks through Prague Castle between 1621 and 1648. The database also provides an idea of the spatial arrangement of imperial collections and aims to become an efficient network for identification and research of “Rudolfine” artworks.     </p>
        <p>
            Inventaria Rudolphina application runs on Node.js server and use MongoDB as database platform. The front-end is built with Semantic&nbsp;UI library and reactive framework Vue.js.
        </p>
        <h4 class="ui header">Project team:</h4>
        <div class="ui list">
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.udu.cas.cz/en/lide/phdr-stepan-vacha-ph-d" target="_blank">Štěpán Vácha - Project Lead</a>
                    <div class="description">
                        Conceptual direction and methodological grounding, project coordination, identification of paintings, and concordances</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header">Martin Meduna - Project Lead IT</a>
                    <div class="description">
                        Database conceptual design, software architecture and design, programming, documentation, website</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.udu.cas.cz/en/lide/mgr-et-mgr-marketa-jezkova-ph-d" target="_blank">Markéta Ježková - Research associate</a>
                    <div class="description">
                        Database conceptual design, TEI encoding, Index of persons, Iconclass index, identification of paintings and concordances</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://independent.academia.edu/StefanBartilla" target="_blank">Stefan Bartilla - Research associate</a>
                    <div class="description">
                        Identification of paintings and concordances</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.udu.cas.cz/en/lide/mgr-sylva-dobalova-ph-d" target="_blank">Sylva Dobalová - Research associate</a>
                    <div class="description">
                        Identification of paintings and concordances</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.ngprague.cz/en/about/people/17/mgr-radka-heisslerova" target="_blank">Radka Heisslerová - Research associate</a>
                    <div class="description">Transcription of manuscripts</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.linkedin.com/in/petr-uli%C4%8Dn%C3%BD-44239a1/" target="_blank">Petr Uličný - Research associate</a>
                    <div class="description">Creation of plans and identification of rooms</div>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.linkedin.com/in/jakubvitak/" target="_blank">Jakub Viták - DevOps Engineer</a>
                    <div class="description">Development and IT Operation, application infrastructure management</div>
                </div>
            </div>
        </div>
</div>
    <div class="four wide column"></div>
</div>


</template>

<script>
   // import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'about',
        data() {
            return {
            }
        },
        mount(){
            
        },
        components: {
          //  TheCarousel
        },
    }
</script>

<style scoped>
    P{
         text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// src/router/aboutdatabase.vue